import { Text, YStack } from "tamagui";
import { CheckboxItem } from "@components/form/utils/CheckboxItem";
import { regAgree } from "@screen/Register/pages/profile/registerFormItem";
import { kiosk } from "../kioskTheme";

/** 與 /register/profile 的 zod 訊息同字（那頁的協議勾選框就是這段文案）。 */
export const AGREE_REQUIRED_MSG = "請閱讀並同意使用者協議";

// 文案與「使用者協議」彈窗沿用註冊頁的 regAgree（只 import、不改它）；id 換掉避免與註冊頁的 "agree" 撞名。
const AGREE_DATA = { ...regAgree.data, id: "checkoutAgree" };

/**
 * 結算頁「我已同意 LPG Cloud 的使用者協議」勾選框。
 * 只在需要驗證手機的客戶面前出現（掛在 OtpCard 的確認段）；同意與否只在前端擋，後端不存（跟舊註冊頁一樣）。
 */
const CheckoutAgreement = ({ checked, onChange, showError }: { checked: boolean; onChange: (v: boolean) => void; showError?: boolean }) => (
  <YStack gap={4}>
    <CheckboxItem data={AGREE_DATA} checked={checked} onChange={(v) => onChange(v === true)} />
    {!!showError && !checked && (
      <Text fontSize={13} color={kiosk.danger} fontWeight="600">
        {AGREE_REQUIRED_MSG}
      </Text>
    )}
  </YStack>
);

export default CheckoutAgreement;
